// import React from 'react'
// import '../CSS/About.css'

// const About = () => {
//   return (
//     <div className='AboutWrap'>
//         <div className='About'>
//             <div className='AboutLeft'>
//                 <img/>
//             </div>
//             <div className='AboutRight'>
//                 <h1>About</h1>
//                 <p>Write About Ambassador</p>
//             </div>
//         </div>
//     </div>
//   )
// }

// export default About

import React from 'react';
import '../CSS/About.css'; // Importing the CSS file
import AboutPic from "../Images/Ambassador About.jpeg"
import Intro from '../Images/INTRO-CHINEDU PROFILE.mp4'

const About = () => {
  return (
    <div className="about-container" id="about">
      {/* <img 
        src={AboutPic} 
        alt="Engir Chinedu Joseph Ndu" 
        className="profile-image" 
      /> */}
       <video
        src={Intro} // Replace with your video file URL
        loop
        controls
        className='AboutIntro'
      />
      <div className="about-text">
        <h2>About</h2>
        <p>
          I am a civil engineer with over 10 years of working experience, with vast 
          knowledge in digitalization of engineering processes, infrastructural 
          design, structural designs from a consultancy perspective, smart design and 
          presentations, and project management experience. Currently working as 
          a BIM Structural Engineer on a U.S.A project.
        </p>
        <p>
          I am a BIM Specialist and Scan To BIM Specialist, I push all boundaries 
          of innovations when it is paramount.
        </p>
      </div>
    </div>
  );
}

export default About;

